export default __webpack_public_path__ + "static/696-a75005bbc13f23e7513d86f46c16e233.gif";